<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Sistem tidak akan dapat menambahan produk baru dengan data kode
          master (contoh: AJYRAXX) yang sama di dalam asset yang dipilih.</FormNote
        >
        <FormRow class="mb-4" :required="true">
          <template #label>Asset</template>
          <template #field>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.asset.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Search asset"
              :showLabels="false"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.asset.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.asset.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Product Group</template>
          <template #field>
            <multiselect
              v-model="formData.group"
              :options="listProductGroup"
              :loading="listProductGroupLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.group.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Search product group"
              :showLabels="false"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.group.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.group.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Product Category</template>
          <template #field>
            <multiselect
              v-model="formData.category"
              :options="listProductCategory"
              :loading="listProductCategoryLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.category.$error ? 'multiselect--error' : ''"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Search product category"
              :showLabels="false"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.category.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.category.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Name</template>
          <template #field>
            <input
              :class="{
                'form__input--error': $v.formData.name.$error && formSubmitted,
              }"
              type="text"
              class="form__input"
              placeholder="Name"
              v-model="formData.name"
            />
            <div
              class="form-error"
              v-if="$v.formData.name.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.name.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Master</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.master.$error && formSubmitted,
              }"
              type="text"
              class="form__input"
              placeholder="Master (e.g: AJYRAXX)"
              v-model="formData.master"
            />
            <div
              class="form-error"
              v-if="$v.formData.master.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.master.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Initial Credit</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.credit.$error && formSubmitted,
              }"
              type="text"
              class="form__input"
              placeholder="Initial Credit"
              v-model="formData.credit"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.credit.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.credit.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div class="ml-4">
              or
              <router-link :to="{ name: 'ProductList' }" class="link ml-2"
                >Back to List Products</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { getListProductOptionsMixin } from "@/mixins/getListProductOptionsMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  directives: {
    currency: CurrencyDirective,
  },
  components: {
    Multiselect,
  },
  mixins: [getListAssetMixin, getListProductOptionsMixin, submitFormMixin],
  data: () => {
    return {
      listProductGroup: [],
      listProductGroupLoading: true,

      listProductCategory: [],
      listProductCategoryLoading: true,

      listAsset: [],
      listAssetLoading: true,

      formData: {
        asset: null,
        group: null,
        category: null,
      },
    };
  },
  validations: {
    formData: {
      name: {
        required,
      },
      master: {
        required,
      },
      asset: {
        required,
      },
      category: {
        required,
      },
      group: {
        required,
      },
      credit: {
        required,
      },
    },
  },
  created() {
    this.getListAsset();
    this.getListProductCategory();
    this.getListProductGroup();
  },
  methods: {},
};
</script>
